import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createUploadLink } from 'apollo-upload-client';
import config from '../config';

const client = new ApolloClient({
  link: createUploadLink({
    uri: config.graphql.uri,
    fetch: (uri, options) => {
      let operationName;
      if (options.body instanceof FormData) {
        try {
          const operations = options.body.get('operations');
          operationName = JSON.parse(operations).operationName;
        } catch (error) {
          // IEの場合FormData.getはサポートしないため、QSをsendMessage(WithCreateCustomer)固定
          operationName = 'sendMessage(WithCreateCustomer)';
        }
      } else {
        try {
          operationName = JSON.parse(options.body).operationName;
        } catch (error) {}
      }
      return fetch(`${uri}?op=${operationName}`, options);
    },
  }),
  credentials: 'include',
  cache: new InMemoryCache(),
  onError: ({ graphQLErrors, networkError, reponse }) => {
    if (graphQLErrors) {
      graphQLErrors.map(({ message, locations, path, extensions }) => {
        console.log(
          `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}, ExtensionsCode: ${
            extensions.code || ''
          }`,
        );
        if (extensions.code === 'UNAUTHENTICATED' && message === 'ログインしてください。') {
          location.href = '/login';
        } else if (['FORBIDDEN', 'NOT_FOUND'].includes(extensions.code)) {
          location.href = '/notFound';
        }
      });
    }
    if (networkError) console.log(`[Network error]: ${networkError}`);
  },
});

export default client;
